import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast.service';
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: 'app-toast',
    imports: [CommonModule, MatIcon],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, AfterViewInit {
  @Input() notificationInfo: any;
  @Output() selectedChanged = new EventEmitter<boolean>();
  selected = false;
  isMobileWidth: boolean = false;
  positionTop: string = '80px';

  constructor(public toastService: ToastService) {}

  remove(index: number) {
    this.toastService.remove(index);
  }

  ngOnInit(): void {
    this.getWidthOfScreenSize();
  }

  ngAfterViewInit() {
    this.getWidthOfScreenSize();
  }

  @HostListener('window:resize')
  getWidthOfScreenSize() {
    let priceCard = false;
    this.toastService.toasts.forEach((toast) => {
      if (toast.priceCard) priceCard = true;
    });
    
    const screenWidth = window.innerWidth;
    this.isMobileWidth = screenWidth < 1280;

    if (this.isMobileWidth) {
      this.positionTop = '60px';
    } else if (priceCard) {
      this.positionTop = '310px';
    } else {
      this.positionTop = '80px';
    }
  }

  selectNotification() {
    this.selectedChanged.emit(!this.selected);
  }
}
